// service/Ciclos.js
import instance from "../apis/app";
import { errorDeApi } from "./client";

/**
 * Cierra el ciclo actual de un taller
 */
const CerrarCiclo = async (tallerId, datos = {}) => {
  try {
    const { motivoCierre = 'cierre_manual', notas = '' } = datos;
    
    const response = await instance.post(`/ciclos/taller/${tallerId}/cerrar-ciclo`, {
      motivoCierre,
      notas
    });
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};


/**
 * 🆕 Cierra ciclos de múltiples talleres
 */
const CerrarMasivo = async (talleresIds = [], datos = {}) => {
  try {
    const { motivoCierre = 'cierre_manual', notas = '' } = datos;
    const response = await instance.post('/ciclos/cerrar-masivo', {
      talleresIds,
      motivoCierre,
      notas,
    });
    return response.data; // incluye { success, resultados, errores, mensaje }
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Inicia nuevo ciclo para uno o más talleres
 */
const IniciarNuevoCiclo = async (talleresIds, datosNuevoCiclo) => {
  try {
    const response = await instance.post('/ciclos/iniciar-nuevo-ciclo', {
      talleresIds,
      datosNuevoCiclo
    });
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};

/**
 * Obtiene talleres disponibles para iniciar nuevo ciclo
 */
const ObtenerTalleresDisponibles = async () => {
  try {
    const response = await instance.get('/ciclos/talleres-disponibles');
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};

/**
 * Obtiene talleres en ciclo activo
 */
const ObtenerTalleresEnCiclo = async () => {
  try {
    const response = await instance.get('/ciclos/talleres-en-ciclo');
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};

/**
 * Obtiene el historial de ciclos de un taller con paginación
 */
const ObtenerHistorialCiclos = async (tallerId, opciones = {}) => {
  try {
    const { page = 1, limit = 10 } = opciones;
    
    const response = await instance.get(
      `/ciclos/taller/${tallerId}/historial?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};

/**
 * Obtiene el detalle completo de un ciclo específico
 */
const ObtenerDetalleCiclo = async (cicloId) => {
  try {
    const response = await instance.get(`/ciclos/ciclo/${cicloId}`);
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};

/**
 * Obtiene estadísticas generales de ciclos
 */
const ObtenerEstadisticas = async () => {
  try {
    const response = await instance.get('/ciclos/estadisticas');
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};

/**
 * Verifica manualmente ciclos que deben cerrarse por fecha
 * (endpoint manual para admin/coordinador)
 */
const VerificarCiclosPorFecha = async () => {
  try {
    const response = await instance.post('/ciclos/verificar-ciclos-fecha');
    return response.data;
  } catch (error) {
    throw errorDeApi(error);
  }
};

export default {
  CerrarCiclo,
  IniciarNuevoCiclo,
  ObtenerTalleresDisponibles,
  ObtenerTalleresEnCiclo,
  ObtenerHistorialCiclos,
  ObtenerDetalleCiclo,
  ObtenerEstadisticas,
  VerificarCiclosPorFecha,
  CerrarMasivo,
};
